import { createServerFn } from "@tanstack/react-start";
import { createClient } from "@supabase/supabase-js";

export type BlocketVehicleCard = {
  external_id: string;
  title: string | null;
  price: number | null;
  category: string;
  image_url: string | null;
  listing_url: string;
  is_sold: boolean;
};

export const getBlocketVehicles = createServerFn({ method: "GET" }).handler(
  async (): Promise<{ items: BlocketVehicleCard[] }> => {
    const supabase = createClient(
      process.env.SUPABASE_URL!,
      process.env.SUPABASE_PUBLISHABLE_KEY!,
      { auth: { storage: undefined, persistSession: false, autoRefreshToken: false } },
    );

    const { data } = await supabase
      .from("vehicle_snapshots")
      .select("external_id, title, price, category, image_url, listing_url, marked_sold_at")
      .eq("source", "blocket")
      .is("sold_at", null)
      .order("marked_sold_at", { ascending: true, nullsFirst: true })
      .limit(100);

    const items: BlocketVehicleCard[] = (data ?? [])
      .filter((r) => r.listing_url && r.image_url)
      .map((r) => ({
        external_id: r.external_id,
        title: r.title,
        price: r.price,
        category: r.category ?? "annat",
        image_url: r.image_url,
        listing_url: r.listing_url!,
        is_sold: !!r.marked_sold_at,
      }));

    return { items };
  },
);
